
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SEPSISSIRS1',
components: {
XTable
},
data () {
return {
form: {
data1: '0',
data2: '0',
data3: '0',
data4: '0'
},
descTxt: ''
}
},
computed: {
score () {
let self = this
let form = JSON.parse(JSON.stringify(self.form))
console.log(form, 22)
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (form[key] !== '0') {
form[key] = 1
} else {
form[key] = 0
}
}
}
let result = form.data1 + form.data2 + form.data3 + form.data4
console.log(result, 777)
if (result >= 2) {
return 'SIRS诊断成立'
} else {
return ''
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/SEPSISSIRS1.vue